import React from 'react'
import { Icon } from 'antd'
import {
  MORE_ITEM_TYPES,
  NEW_ITEM_DROPDOWN_QUICK_LINKS,
} from '@edulastic/constants/const/addQuestionQuickLinks'
import { connect } from 'react-redux'
import { themeColorBlue, white } from '@edulastic/colors'
import {
  Button,
  Menu,
  MenuItem,
  MenuTrigger,
  Popover,
} from 'react-aria-components'
import styled from 'styled-components'
import { Divider } from '../../../ItemDetail/components/SettingsBar/components/SettingsBarIcon/styled'
import {
  isDynamicTestSelector,
  isSurveyTestSelector,
} from '../../../TestPage/ducks'
import { StyledButtonInnerContainer, StyledEduButton } from './styled'

const QuickLinksMenu = ({ onItemClick }) => {
  const menuItems = [...NEW_ITEM_DROPDOWN_QUICK_LINKS, MORE_ITEM_TYPES]

  return (
    <StyledPopover>
      <StyledMenu>
        {menuItems.map((item) => {
          return (
            <StyledMenuItem
              onAction={() => onItemClick(item.key)}
              data-cy={`${
                item.key === MORE_ITEM_TYPES.key ? 'quick-link-' : ''
              }${item.dataCy}`}
            >
              <div>
                {item.icon}
                <span style={{ marginLeft: '12px' }}>{item.label}</span>
              </div>
            </StyledMenuItem>
          )
        })}
      </StyledMenu>
    </StyledPopover>
  )
}

export const QuickLinkDropDown = ({ onItemClick, disabled }) => {
  return (
    <MenuTrigger>
      <StyledMenuButton
        isDisabled={disabled}
        data-cy="item-quick-links-dd"
        aria-label="Create New Item Menu"
      >
        <Icon type="down" style={{ color: 'white' }} />
      </StyledMenuButton>
      <QuickLinksMenu onItemClick={onItemClick} />
    </MenuTrigger>
  )
}

const NewItemQuickLinkButton = ({
  children,
  onClick,
  isSurveyTest,
  isDynamicTest,
  ...props
}) => {
  const showQuickLinks = !(isSurveyTest || isDynamicTest)

  return (
    <StyledEduButton
      {...props}
      showQuickLinks={showQuickLinks}
      onClick={() => onClick()}
    >
      <StyledButtonInnerContainer>{children}</StyledButtonInnerContainer>
      {showQuickLinks && (
        <>
          <Divider
            getMarginLeft={(f) => f}
            style={{ background: 'white', height: 'inherit' }}
          />
          <QuickLinkDropDown onItemClick={onClick} />
        </>
      )}
    </StyledEduButton>
  )
}

export default connect((state) => ({
  isSurveyTest: isSurveyTestSelector(state),
  isDynamicTest: isDynamicTestSelector(state),
}))(NewItemQuickLinkButton)

const StyledMenuButton = styled(Button)`
  background: none;
  border: none;
  padding: 0px;
  cursor: pointer;
  height: 28px;
  svg {
    width: 12px;
  }
`

const StyledPopover = styled(Popover)`
  background: white;
  font-size: 14px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: inherit;
  overflow: auto;
  forced-color-adjust: none;
  outline: none;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 10px 0px;
`

const StyledMenu = styled(Menu)``

const StyledMenuItem = styled(MenuItem)`
  cursor: pointer;
  padding: 8px 15px;
  &:hover,
  &:focus {
    background: ${themeColorBlue};
    color: ${white};
    svg {
      fill: ${white};
    }
  }
  svg {
    margin-bottom: -4px;
  }
`
